// extracted by mini-css-extract-plugin
export default {"page":"wW-z","cartModal":"xW-z","checkout":"yW-z","placeholder":"zW-z","account":"AW-z"};